export default __webpack_public_path__ + "static/media/booking.c7a6167f.svg";